// Form validation for SOP
import { plaintextValidator, multiselectValidator } from '../fields';

const config = {};

export default {
  name: plaintextValidator({ mandatory: true }),
  approverList: multiselectValidator(config)
};
